import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import utils, { comnEnvs, comnUtils } from "@/comn/utils";
import { Button, Grid, Group, Layout, Page, Tree } from "@/comn/components";
import {
    useFetch,
    useForm,
    useGrid,
    useStore,
    useTheme,
    useToast,
    useResource,
    useModal,
    usePage,
    useTree,
    useAuth,
} from "@/comn/hooks";
import {
    APIS,
    SF_ORG_DEPT_SRCH,
    SG_SCTN_LIST,
    SF_ORG_DEPT_INFO,
    URLS,
} from "@/tz/go/egaz/osci/ptl/usr/orgdept/serivces/OsciOrgDeptService";
import { ptlUtils } from "../../comn";

/*
 * Organization Department List
 * !== 조직 관리 목록 ==!
 */
export const OSCI0103009Q = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003", "auth_osci0002"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal();
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const tree = useTree(); // Tree Hook !== Tree Hook ==!
    const { theme } = useTheme();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const [orgCd, setOrgCd] = useState<string>("");
    const { getResource, updateResource } = useResource({
        defaultSchema: [{ area: "orgDeptCd" }, { area: "orgCd" }, { area: "comnCd", comnCd: "OSC0156" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Organization Department List Search !== 조직 목록 검색 ==!
        orgDeptListSrch: useForm({
            defaultSchema: SF_ORG_DEPT_SRCH,
            defaultValues: { ...pgeStore?.form },
        }),

        // Organization Department Info !== 조직 상세 ==!
        orgDeptInfo: useForm({
            defaultSchema: SF_ORG_DEPT_INFO,
            defaultValues: {},
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Section List !== 섹션 목록 ==!
        sctnList: useGrid({
            defaultSchema: SG_SCTN_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        //Check Organazations List !==  기관 부서 목록 조회 ==!
        getOrgDeptList: useFetch({
            api: () => APIS.getOrgDeptList(form.orgDeptListSrch.getValues()),
            onSuccess: (data) => {
                console.log(data);
                const orgDeptList = data["orgDeptList"].content;

                let uprDeptCdNm;
                if (!comnUtils.isEmpty(orgDeptList)) {
                    uprDeptCdNm = orgDeptList[0].uprDeptCdNm;
                } else {
                    uprDeptCdNm = "ROOT";
                }
                tree.setData([
                    {
                        name: uprDeptCdNm,
                        deptPath: uprDeptCdNm,
                        children: handler.createTreeData(orgDeptList, [], 1, ""),
                    },
                ]);
                tree.openTree();
                form.orgDeptInfo.setValue("startFlag", true);

                const orgCd = form.orgDeptListSrch.getValue("orgCd");
                setOrgCd(orgCd);
            },
            onError: (data) => {
                tree.setData([]);
                form.orgDeptInfo.setValue("startFlag", false);
                setOrgCd(orgCd);
                modal.openModal({ content: data.response.data.errorMessage });
            },
            showToast: true,
        }),
        // Check Organization Department Information !== 기관 부서 정보 조회 ==!
        getOrgDeptInfo: useFetch({
            api: (data) => APIS.getOrgDeptInfo(data),
            onSuccess: (data) => {
                const orgDeptInfo = data.orgDeptInfo.content;
                form.orgDeptInfo.reset();
                form.orgDeptInfo.setValues(orgDeptInfo);

                form.orgDeptInfo.setEditable(true);
                form.orgDeptInfo.setEditable("deptCd", false);
            },
            onError: (error) => {},
        }),
        // Create Organization Department !== 기관 부서 등록 ==!
        createOrgDept: useFetch({
            api: (data) => APIS.createOrgDept({ ...data }),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00073", // Successfully saved., !== 정상적으로 저장되었습니다. ==!
                    onConfirm: () => {
                        afterSave();
                    },
                    close: false,
                });
            },
            onError: (error) => {
                console.log(error);
                const data = error.response.data;
                if (error.response.status === 400) {
                    form.orgDeptInfo.setErrors(error.response.data.errors);
                }

                modal.openModal({
                    content: data.errorMessage,
                });
            },
        }),
        // Update Organization Department !== 기관 부서 수정 ==!
        updateOrgDept: useFetch({
            api: (data) => APIS.updateOrgDept({ ...data }),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00073", // Successfully saved., !== 정상적으로 저장되었습니다. ==!
                    onConfirm: () => {
                        afterSave();
                    },
                    close: false,
                });
            },
            onError: (error) => {
                console.log(error);
                const data = error.response.data;
                if (error.response.status === 400) {
                    form.orgDeptInfo.setErrors(error.response.data.errors);
                }

                modal.openModal({
                    content: data.errorMessage,
                });
            },
        }),
        // delete Organization Department !== 기관 부서 삭제 ==!
        deleteOrgDept: useFetch({
            api: (orgCd) => APIS.deleteOrgDept(orgCd),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00071", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                    onConfirm: () => {
                        (async () => {
                            await (async () => {
                                form.orgDeptInfo.reset();
                                form.orgDeptInfo.setEditable(false);
                                fetch.getOrgDeptList.fetch();
                            })();
                            await (async () => {
                                // 삭제 후 버튼 초기화 되지 않는 현상 수정
                                form.orgDeptInfo.setValue("newYn", false);
                            })();
                        })();
                    },
                    close: false,
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };
    const render = {};

    const newInit = () => {
        form.orgDeptInfo.setEditable(true);
        form.orgDeptInfo.clearValues();
        form.orgDeptInfo.clearErrors();
        // Reset 또는 기관 전환 이후 신규 등록 시 상위 부서 입력과 팝업을 다시 활성화한다.
        form.orgDeptInfo.setSchema("uprDeptCd", { readOnly: false, disabled: false });

        form.orgDeptInfo.setValue("newYn", false);
        form.orgDeptInfo.setValue("saveYn", true);
        form.orgDeptInfo.setValue("useYn", "Y");
    };

    const afterSave = () => {
        updateResource("orgDeptCd");
        fetch.getOrgDeptList.fetch();
        form.orgDeptInfo.setEditable(false);
        form.orgDeptInfo.clearValues();
        form.orgDeptInfo.setValue("newYn", false);
    };
    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Click Search Button !== 검색버튼 ==!
        onSrchBtnClick: () => {
            if (!comnUtils.isEmpty(form.orgDeptListSrch.errors)) {
                toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.orgDeptListSrch.handleSubmit(
                () => {
                    fetch.getOrgDeptList.fetch();
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },

        //부서 목록 조회해서 데이터 뿌려주기
        createTreeData: (deptList: any, newList: any, level: any, deptCd: any) => {
            const tempList = deptList
                .map((item: any) => {
                    const result = {
                        name: comnUtils.replaceEmpty(item.deptCdNm),
                        checkbox: false,
                        deptCd: comnUtils.replaceEmpty(item.deptCd),
                        deptNm: comnUtils.replaceEmpty(item.deptCdNm),
                        orgzLvl: comnUtils.replaceEmpty(item.orgzLvl, 0),
                        deptIdtnOrd: comnUtils.replaceEmpty(item.deptIdtnOrd, 0),
                        uprDeptCd: comnUtils.replaceEmpty(item.uprDeptCd),
                        orgCd: comnUtils.replaceEmpty(item.orgCd),
                    };

                    return result;
                })
                .filter((item: any) => item.orgzLvl == level && item.uprDeptCd == deptCd);

            //필터로 계층구조 필터링
            if (tempList.length === 0) return newList;

            tempList.forEach((item: any) => {
                if (!item.children) item.children = [];
                handler.createTreeData(deptList, item.children, item["orgzLvl"] * 1 + 1, item["deptCd"]);
                newList.push(item);
            });

            return newList;
        },

        //Click Organization Department List Tree !== 기관 트리 클릭 ==!
        onTreeClick: (treeInfo: any) => {
            if (treeInfo.depth === 0) {
                form.orgDeptInfo.setEditable(false);
                form.orgDeptInfo.clearValues();
                form.orgDeptInfo.setValue("newYn", false);
                form.orgDeptInfo.setValue("startFlag", true);
                form.orgDeptInfo.setSchema("uprDeptCd", { readOnly: true, disabled: true });
                return;
            } else if (treeInfo.depth === 1) {
                form.orgDeptInfo.setSchema("uprDeptCd", { readOnly: true, disabled: true });
            } else {
                form.orgDeptInfo.setSchema("uprDeptCd", { readOnly: false, disabled: false });
            }
            fetch.getOrgDeptInfo.fetch(treeInfo);
        },

        // Click New Button !== 신규 버튼 ==!
        onBtnNewClick: () => {
            newInit();
        },
        // Click Add Sub Department Button !== 신규 하위 부서 추가 버튼 ==!
        onBtnAddSubDeptClick: () => {
            let deptCd = form.orgDeptInfo.getValue("deptCd");
            newInit();

            form.orgDeptInfo.setValue("uprDeptCd", deptCd);
        },
        // Click Save Button !== 신규 저장 버튼 클릭  ==!
        onBtnSaveClick: () => {
            if (!comnUtils.isEmpty(form.orgDeptInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }
            form.orgDeptInfo.handleSubmit(
                () => {
                    const data = form.orgDeptInfo.getValues();
                    if (!comnUtils.isEmpty(orgCd)) {
                        data.orgCd = orgCd;

                        modal.openModal({
                            content: "msg.osc.00090", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                            onConfirm: () => {
                                fetch.createOrgDept.fetch(data);
                            },
                            close: false,
                        });
                    } else {
                        toast.showToast({ type: "warning", content: "msg.osc.00008" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                        return;
                    }
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
        // Click Edit Button !== 신규 저장 버튼 클릭  ==!
        onBtnEditClick: () => {
            if (!comnUtils.isEmpty(form.orgDeptInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }
            form.orgDeptInfo.handleSubmit(
                () => {
                    const data = form.orgDeptInfo.getValues();
                    modal.openModal({
                        content: "msg.osc.00090", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.updateOrgDept.fetch(data);
                        },
                        close: false,
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
        // Click Delete Button !== 삭제 버튼 클릭  ==!
        onBtnDeleteClick: () => {
            modal.openModal({
                content: "msg.osc.00062", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () => {
                    fetch.deleteOrgDept.fetch(form.orgDeptInfo.getValues());
                },
            });
        },
        onBtnCancelClick: () => {
            afterSave();
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        const store = getStore(pgeUid);
        if (!comnUtils.isEmpty(store)) {
            form.orgDeptListSrch.setValue("cstmOrgzNm", store.cstmOrgzNm);
            form.orgDeptListSrch.setValue("cstmOrgzTpCd", store.cstmOrgzTpCd);
            // form.orgDeptListSrch.setValue("langCd"   , theme.lang);
        }

        form.orgDeptInfo.setValue("newYn", false);
        form.orgDeptInfo.setValue("saveYn", false);
        form.orgDeptInfo.setValue("startFlag", false);
        if (!ptlUtils.hasAuth("auth_osci0003", auth)) {
            form.orgDeptListSrch.setValue("orgCd", auth.get("orgCd"));
            form.orgDeptListSrch.setSchema("orgCd", { readOnly: true, disabled: true });
            handler.onSrchBtnClick();
        }

        form.orgDeptInfo.setEditable(false);
    }, [theme.lang]);

    const newYn = form.orgDeptInfo.watch("newYn");
    const saveYn = form.orgDeptInfo.watch("saveYn");
    const startFlag = form.orgDeptInfo.watch("startFlag");

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.orgDeptListSrch.schema.orgCd} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button
                                role={"reset"}
                                onClick={() => {
                                    form.orgDeptListSrch.reset();
                                    form.orgDeptInfo.setEditable(false);
                                    form.orgDeptInfo.clearValues();
                                    form.orgDeptInfo.setValue("newYn", false);
                                    form.orgDeptInfo.setValue("startFlag", false);
                                    form.orgDeptInfo.setSchema("uprDeptCd", { readOnly: true, disabled: true });
                                    if (!ptlUtils.hasAuth("auth_osci0003", auth)) {
                                        form.orgDeptListSrch.setValue("orgCd", auth.get("orgCd"));
                                        form.orgDeptListSrch.setSchema("orgCd", { readOnly: true, disabled: true });
                                        handler.onSrchBtnClick();
                                    }
                                    tree.setData([]);
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role={"search"}
                                onClick={() => {
                                    handler.onSrchBtnClick();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Layout gap={4}>
                <Group>
                    <Group.Header>
                        <Group.Title title={"T_ORGZ_LIST"} />
                    </Group.Header>
                    <Group.Body>
                        <Tree {...tree.tree} size={12} height={300} onClick={handler.onTreeClick} />
                        <Layout>
                            <Layout.Right hidden={!startFlag}>
                                <Layout.Button role={"new"} onClick={handler.onBtnNewClick} />
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control
                                    {...form.orgDeptInfo.schema.uprDeptCd}
                                    // Upper Department 팝업과 자동완성 목록을 현재 조회한 기관의 부서로 제한한다.
                                    popupParams={{ orgCd }}
                                    filter={(_option: any, department: any) => department?.orgCd === orgCd}
                                    viewType="label"
                                ></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.orgDeptInfo.schema.deptCd}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.orgDeptInfo.schema.deptNm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.orgDeptInfo.schema.deptDesc}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.orgDeptInfo.schema.deptIdtnOrd}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.orgDeptInfo.schema.useYn}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout>
                            <Layout.Left hidden={saveYn === true}>
                                <Layout.Button onClick={handler.onBtnAddSubDeptClick}>
                                    {t("B_ADD_SUB_DEPT")}
                                </Layout.Button>
                            </Layout.Left>
                            <Layout.Right hidden={!saveYn}>
                                <Layout.Button role={"save"} onClick={handler.onBtnSaveClick} />
                                <Layout.Button role={"cancel"} onClick={handler.onBtnCancelClick} />
                            </Layout.Right>
                            <Layout.Right hidden={newYn === false}>
                                <Layout.Button role={"edit"} onClick={handler.onBtnEditClick} />
                                <Layout.Button role={"delete"} onClick={handler.onBtnDeleteClick} />
                                <Layout.Button role={"cancel"} onClick={handler.onBtnCancelClick} />
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </Layout>
        </Page>
    );
};
